module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "whisper-core": "static-1.2377",
      "central-engagement-orchestrator": "static-1.774",
      "whisper-base": "static-1.2378",
      "whisper-error-tracking": "static-1.1390",
      "whisper-nudge-tracking": "static-1.2378",
      "whisper-skymap-tracking": "static-1.2378",
      "data-fetching-client": "static-1.8194",
      "hub-http": "static-1.4807",
      "nudge-adapter-components": "static-1.634",
      "quartz-core": "static-1.4567",
      "rpc-client-utils": "static-1.3324",
      "enviro": "static-4.297",
      "apollo-stack-hubspot": "static-3.43",
      "graphql": "static-1.58",
      "react": "static-7.151",
      "metrics-js": "static-1.8366",
      "quartz": "static-1.5348",
      "react-dom": "static-7.85",
      "ai-components-ui-library": "static-1.4956",
      "central-engagement-components": "static-1.1291",
      "foundations-components": "static-1.5760",
      "foundations-theming": "static-1.2906",
      "hub-http-janus": "static-1.633",
      "usage-tracker": "static-1.6062",
      "copilot-toolkit": "static-1.5499",
      "dispatcher": "static-1.111",
      "general-store": "static-6.20",
      "HeadJS": "static-2.562",
      "history": "static-4.47",
      "hs-promise-rejection-tracking": "static-1.4103",
      "hs-test-utils": "static-1.6600",
      "hub-http-shared-msw-handlers": "static-1.6836",
      "hubspotter-http": "static-1.3391",
      "hubspotter-http-shared-msw-handlers": "static-1.6834",
      "I18n": "static-7.1368",
      "icons": "static-2.591",
      "jasmine": "static-4.2946",
      "jasmine-runner": "static-1.4991",
      "mobile-manifest-mixins": "static-1.333",
      "msw": "static-1.39",
      "platform-navigation-bootstrap": "static-1.10989",
      "PortalIdParser": "static-2.276",
      "quartz-core-utils": "static-1.2215",
      "quick-fetch": "static-1.2772",
      "raven": "static-3.4569",
      "raven-hubspot": "static-1.4876",
      "react-rhumb": "static-1.15199",
      "react-router-dom": "static-5.26",
      "styled-components": "static-2.40",
      "ui-fonts": "static-1.331",
      "UIComponents": "static-3.7034",
      "csstype": "static-1.38",
      "StyleGuideUI": "static-3.453",
      "autolinker": "static-3.11",
      "chatspot-client-types": "static-1.8336",
      "chatspot-core": "static-1.14746",
      "classnames": "static-2.10",
      "ContentUtils": "static-1.62536",
      "cssUtils": "static-1.455",
      "foundations-assets": "static-1.3511",
      "foundations-theming-base": "static-1.1891",
      "foundations-theming-specialty": "static-1.623",
      "hoist-non-react-statics": "static-3.9",
      "hs-story-utils": "static-1.7987",
      "hubspot-url-utils": "static-1.2984",
      "HubStyle": "static-2.10394",
      "HubStyleTokens": "static-2.10085",
      "immutable": "static-2.19",
      "react-utils": "static-2.4159",
      "sanitize": "static-1.2964",
      "sanitize-text": "static-1.6789",
      "sassPrefix": "static-1.129",
      "ui-images": "static-2.804",
      "usage-tracker-core": "static-1.5912",
      "floating-ui": "static-1.28",
      "trellis-story-utils": "static-1.3150",
      "bend-plugin-foundations-components": "static-1.2028",
      "framer-motion": "static-1.40",
      "moment": "static-3.26",
      "react-aria": "static-1.38",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.73",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.1389",
      "hs-test-utils-bend-plugin": "static-1.1711",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.120",
      "ts-schema": "static-1.2970",
      "i18n-data": "static-1.195",
      "moment-timezone": "static-5.51",
      "platform-infra-nav-components": "static-1.6516",
      "head-dlb": "static-1.3679",
      "cms-field-types": "static-1.3376",
      "content-icons-ui": "static-1.1862",
      "underscore": "static-1.8",
      "webpack-env": "static-1.54",
      "transmute": "static-2.29",
      "react-input-autosize": "static-2.17",
      "hs-lodash": "static-4.45"
    },
    "depPathPrefixes": {
      "whisper-core": "/whisper-core/static-1.2377",
      "central-engagement-orchestrator": "/central-engagement-orchestrator/static-1.774",
      "whisper-base": "/whisper-base/static-1.2378",
      "whisper-error-tracking": "/whisper-error-tracking/static-1.1390",
      "whisper-nudge-tracking": "/whisper-nudge-tracking/static-1.2378",
      "whisper-skymap-tracking": "/whisper-skymap-tracking/static-1.2378",
      "data-fetching-client": "/data-fetching-client/static-1.8194",
      "hub-http": "/hub-http/static-1.4807",
      "nudge-adapter-components": "/nudge-adapter-components/static-1.634",
      "quartz-core": "/quartz-core/static-1.4567",
      "rpc-client-utils": "/rpc-client-utils/static-1.3324",
      "enviro": "/enviro/static-4.297",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "graphql": "/graphql/static-1.58",
      "react": "/react/static-7.151",
      "metrics-js": "/metrics-js/static-1.8366",
      "quartz": "/quartz/static-1.5348",
      "react-dom": "/react-dom/static-7.85",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.4956",
      "central-engagement-components": "/central-engagement-components/static-1.1291",
      "foundations-components": "/foundations-components/static-1.5760",
      "foundations-theming": "/foundations-theming/static-1.2906",
      "hub-http-janus": "/hub-http-janus/static-1.633",
      "usage-tracker": "/usage-tracker/static-1.6062",
      "copilot-toolkit": "/copilot-toolkit/static-1.5499",
      "dispatcher": "/dispatcher/static-1.111",
      "general-store": "/general-store/static-6.20",
      "HeadJS": "/HeadJS/static-2.562",
      "history": "/history/static-4.47",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4103",
      "hs-test-utils": "/hs-test-utils/static-1.6600",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6836",
      "hubspotter-http": "/hubspotter-http/static-1.3391",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6834",
      "I18n": "/I18n/static-7.1368",
      "icons": "/icons/static-2.591",
      "jasmine": "/jasmine/static-4.2946",
      "jasmine-runner": "/jasmine-runner/static-1.4991",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.333",
      "msw": "/msw/static-1.39",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.10989",
      "PortalIdParser": "/PortalIdParser/static-2.276",
      "quartz-core-utils": "/quartz-core-utils/static-1.2215",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "raven": "/raven/static-3.4569",
      "raven-hubspot": "/raven-hubspot/static-1.4876",
      "react-rhumb": "/react-rhumb/static-1.15199",
      "react-router-dom": "/react-router-dom/static-5.26",
      "styled-components": "/styled-components/static-2.40",
      "ui-fonts": "/ui-fonts/static-1.331",
      "UIComponents": "/UIComponents/static-3.7034",
      "csstype": "/csstype/static-1.38",
      "StyleGuideUI": "/StyleGuideUI/static-3.453",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-client-types": "/chatspot-client-types/static-1.8336",
      "chatspot-core": "/chatspot-core/static-1.14746",
      "classnames": "/classnames/static-2.10",
      "ContentUtils": "/ContentUtils/static-1.62536",
      "cssUtils": "/cssUtils/static-1.455",
      "foundations-assets": "/foundations-assets/static-1.3511",
      "foundations-theming-base": "/foundations-theming-base/static-1.1891",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.623",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "hs-story-utils": "/hs-story-utils/static-1.7987",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.2984",
      "HubStyle": "/HubStyle/static-2.10394",
      "HubStyleTokens": "/HubStyleTokens/static-2.10085",
      "immutable": "/immutable/static-2.19",
      "react-utils": "/react-utils/static-2.4159",
      "sanitize": "/sanitize/static-1.2964",
      "sanitize-text": "/sanitize-text/static-1.6789",
      "sassPrefix": "/sassPrefix/static-1.129",
      "ui-images": "/ui-images/static-2.804",
      "usage-tracker-core": "/usage-tracker-core/static-1.5912",
      "floating-ui": "/floating-ui/static-1.28",
      "trellis-story-utils": "/trellis-story-utils/static-1.3150",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2028",
      "framer-motion": "/framer-motion/static-1.40",
      "moment": "/moment/static-3.26",
      "react-aria": "/react-aria/static-1.38",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.73",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1389",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1711",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.120",
      "ts-schema": "/ts-schema/static-1.2970",
      "i18n-data": "/i18n-data/static-1.195",
      "moment-timezone": "/moment-timezone/static-5.51",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6516",
      "head-dlb": "/head-dlb/static-1.3679",
      "cms-field-types": "/cms-field-types/static-1.3376",
      "content-icons-ui": "/content-icons-ui/static-1.1862",
      "underscore": "/underscore/static-1.8",
      "webpack-env": "/webpack-env/static-1.54",
      "transmute": "/transmute/static-2.29",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "hs-lodash": "/hs-lodash/static-4.45"
    },
    "project": "whisper-core",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};